export function isInTeams(): boolean {
  return window.parent.length > 0 && window.parent !== window.self;
}